import React, { useState, useEffect } from 'react';
import {
  Card, CardContent, CardActions, Typography, Box, Stack, CircularProgress,
  IconButton, Tooltip, Grid, Dialog, DialogTitle, DialogContent, DialogActions, Button
} from '@mui/material';
import { PrintOutlined as PrintOutlinedIcon, Visibility as VisibilityIcon, FileDownload as DownloadIcon } from '@mui/icons-material';
import axios from 'axios';
import utils from '../../utils';
import ReactMarkdown from 'react-markdown';

const CliNews = () => {
  const [newsList, setNewsList] = useState([]);
  const [loading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const res = await axios.get(`/api/newsclienti`, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        setNewsList(res.data.news);
      } else {
        console.error(error);
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const handlePrint = (news) => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
        <head>
          <title>Print News</title>
          <style>
            body { font-family: Arial, sans-serif; }
            .news-content { white-space: pre-line; }
            .news-header { text-align: center; margin-bottom: 20px; }
            .news-title { font-size: 1.5em; font-weight: bold; }
            .news-date { font-size: 1em; color: gray; }
            .header-image {
            width: 30%; /* Ridimensiona l'immagine */
            max-width: 300px; /* Limita la larghezza massima */
            margin: -50px auto 0px; /* Sposta l'immagine più in alto e centra */
            display: block;
          }
          </style>
        </head>
        <body>
        <img src="/CartaIntestata.svg" alt="Carta Intestata" class="header-image" />
          <div class="news-header">
            <div class="news-title">${news.title}</div>
            <div class="news-date">${new Date(news.date).toLocaleDateString()}</div>
          </div>
          <div class="news-content">${news.content}</div>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  const handleClickOpen = (news) => {
    setSelectedNews(news);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ marginTop: '5px', padding: 3 }}>
      <Typography variant="h4" component="h2" gutterBottom sx={{ textAlign: 'center', marginBottom: '10px', color: '#2c3e50', fontWeight: 'bold' }}>
        Circolari
      </Typography>
      {loading ? (
        <Stack sx={{ my: 5 }} alignItems="center">
          <CircularProgress disableShrink sx={{ color: '#3498db' }} />
        </Stack>
      ) : (
        <Grid container spacing={4}>
          {newsList.map((news) => (
            <Grid item xs={12} sm={6} md={4} key={news.id}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                  borderRadius: '12px',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 6px 25px rgba(0, 0, 0, 0.15)',
                  },
                }}
              >
                <CardContent sx={{ flexGrow: 1, cursor: 'pointer', p: 2 }} onClick={() => handleClickOpen(news)}>
                  <Typography
                    gutterBottom
                    variant="h6"
                    component="div"
                    sx={{
                      fontWeight: 'bold',
                      color: '#2c3e50',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {news.title}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 0 }}>
                    Categoria: {news.category} | Data: {new Date(news.date).toLocaleDateString()}
                  </Typography>
                </CardContent>
                <CardActions sx={{ justifyContent: 'flex-end', p: 0 }}>
                  <IconButton aria-label="print" onClick={() => handlePrint(news)} sx={{ color: '#3498db' }}>
                    <PrintOutlinedIcon />
                  </IconButton>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle sx={{ fontWeight: 'bold', color: '#2c3e50' }}>{selectedNews?.title}</DialogTitle>
        <DialogContent>
          <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 2 }}>
            Categoria: {selectedNews?.category} | Data: {selectedNews && new Date(selectedNews.date).toLocaleDateString()}
          </Typography>
          <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
            {selectedNews?.content}
          </Typography>
          {selectedNews?.files && selectedNews.files.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold', color: '#2c3e50' }}>File Allegati:</Typography>
              {selectedNews.files.map((file, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <Typography variant="body2">{file.name}</Typography>
                  {file.name.endsWith('.pdf') && (
                    <Tooltip title="Anteprima">
                      <IconButton onClick={() => utils.cliOpenPdfInNewTab(file.id)} sx={{ color: '#3498db' }}>
                        <VisibilityIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Tooltip title="Scarica">
                    <IconButton onClick={() => utils.cliDownload(file.id)} download sx={{ color: '#3498db' }}>
                      <DownloadIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} sx={{ color: '#3498db' }}>Chiudi</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CliNews;
